const groupBy = (data = [], key) => {
  return data.reduce((obj, n) => {
    const objKey = n[key];
    obj[objKey] = obj[objKey] || [];
    obj[objKey].push(n);
    return obj;
  }, {});
};

export default groupBy;
